import type { AppConfig } from "@/lib/types";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import { LayoutTemplate, Zap } from "lucide-react";

export function ModeTabs({ config, onChange }: { config: AppConfig, onChange: (config: AppConfig) => void; }) {
    return (
        <div className="flex items-center gap-2 p-1 bg-input/20 rounded-xl border border-border/50">
            <Button
                variant={config.renderMode === 'classic' ? 'default' : 'ghost'}
                className={cn(
                    "flex-1 h-9 rounded-lg text-[10px] font-bold uppercase tracking-widest gap-2 shadow-none transition-all",
                    config.renderMode !== 'classic' && "hover:bg-white/10 hover:text-foreground"
                )}
                onClick={() => onChange({ ...config, renderMode: 'classic' })}
            >
                <LayoutTemplate className="size-3.5" />
                Classic Mode
            </Button>
            <Button
                variant={config.renderMode === 'sync' ? 'default' : 'ghost'}
                className={cn(
                    "flex-1 h-9 rounded-lg text-[10px] font-bold uppercase tracking-widest gap-2 shadow-none transition-all",
                    config.renderMode !== 'sync' && "hover:bg-white/10 hover:text-foreground"
                )}
                onClick={() => onChange({ ...config, renderMode: 'sync' })}
            >
                <Zap className="size-3.5" />
                Sync Mode
            </Button>
        </div>
    )
}